/**
 * @author - Andy Howell
 *
 *
 */
(function() {
    'use strict';

    angular.module('vhols')

        .service('sessionStorage', ["$window", "$log", function($window, $log) {
            var service = {
                set: function(key, value) {
                    try {
                        $window.sessionStorage.setItem(key, value);
                    } catch (error) {
                        $log.error(error);
                    }
                },

                get: function(key) {
                    try {
                        return $window.sessionStorage.getItem(key);
                    } catch (error) {
                        $log.error(error);
                    }
                }
            };

            return service;
        }]);
})();